import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'app/shared/services/api.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss']
})
export class AddComponent implements OnInit {

    @ViewChild('vform') validationForm: FormGroup;
  
    OpeningForm:FormGroup;
    categories=[]
    tagsFormSubmitted:boolean=false;


    model={
        title: '',
        salary: '',
        website: '',
        deadline: '',
        location: '',
        posted_date: '',
        description: '',
        contact_email: '',
        contact_phone: '',
        responsibilities: '',
        status: '',
        job_id: '',
        company: '',
        category: '',
        employment_type: '',
        notes: '',
        admin_notes: '',
        experience:0,
        sort_listed:[],
        applied_for:[]
    }

    emp_type_list=[]
    selected_type = null

    opening_status_cat_id ='64c246476ae6f958da59fae3'
    opening_cate_cat_id = '64c2446a6ae6f958da59faaa'
    status_list =[]
    selected_status = null
    category_list =[]
    selected_category = null
    job_list =[]
    selected_job = null
    company_list =[]
    selected_company = null

    business_type_company_id = '6325ce10bc4b543c7a2429ad' // company

  opening_id: any
  users_list = []
  selected_user = null
  selected_shortlist_user =null
  currentUrl:any
  experince_Value=0
  public someTimeConfig: any = {
    start: 86400 / 2,
    range: {
      min: 0,
      max: 20
    },
    tooltips: [true],
    format: {
      to: (value: number) => Math.round(value).toString(), // Format tooltip value
      from: (value: string) => parseFloat(value)
    },
    step: 1
  };
  
    constructor(private formBuilder: FormBuilder,
                public toastr: ToastrService,
                public apiService:ApiService,
                private route: Router, private activatedroute: ActivatedRoute) { 
                  this.currentUrl=this.activatedroute.snapshot.routeConfig.path
                  this.activatedroute.paramMap.subscribe(params => { 
                  this.opening_id = params.get('id'); 
                  });    
                  this.getAllCandidate()
                  this.getJobList()
                  this.getCompanyList()
                }
  
    ngOnInit() {
      this.getEmployeeStatusList()
      this.getStatusList()
      this.getCategoryList()
      
      

      this.OpeningForm=this.formBuilder.group({
        title: ['',Validators.required],
        salary: ['',],
        website: ['',],
        deadline: ['',],
        location: ['',],
        posted_date: ['',],
        description: ['',],
        contact_email: ['',],
        contact_phone: ['',],
        responsibilities: ['',],
        company: ['',],
        category: ['',],
        notes: ['',],
        admin_notes: ['',]
      })
      if(this.opening_id && this.currentUrl =='edit/:id'){
        this.getOpeningById(this.opening_id)
      }
    }
    getOpeningById(id){

      this.apiService.getOpeningById(id).subscribe((res:any)=>{
        this.model.title = res?.data[0]?.title
        this.model.salary = res?.data[0]?.salary
        this.model.website = res?.data[0]?.website
        this.model.deadline = res?.data[0]?.deadline
        this.model.location = res?.data[0]?.location
        this.model.posted_date = res?.data[0]?.posted_date
        this.model.description = res?.data[0]?.description
        this.model.contact_email = res?.data[0]?.contact_email
        this.model.contact_phone = res?.data[0]?.contact_phone
        this.model.responsibilities = res?.data[0]?.responsibilities
        this.model.notes = res?.data[0]?.notes
        this.model.admin_notes = res?.data[0]?.admin_notes
        this.experince_Value = res?.data[0]?.experience
        this.model.experience = this.experince_Value
        this.selected_company = res?.data[0]?.company?._id
        this.model.company = this.selected_company

        this.selected_category = res?.data[0]?.category?._id
        this.model.category = this.selected_category

        this.selected_job =  res?.data[0]?.job_id?._id
        this.model.job_id = this.selected_job

        this.selected_status =  res?.data[0]?.status?._id
        this.model.job_id = this.selected_status

        this.selected_type =  res?.data[0]?.employment_type?._id
        this.model.employment_type = this.selected_status

        if( res?.data[0]?.applied_for){
          this.selected_user = res?.data[0]?.applied_for.map(item => item._id)
          this.model.applied_for = this.selected_user
        }
        if(res?.data[0]?.sort_listed){
          this.selected_shortlist_user = res?.data[0]?.sort_listed.map(item => item._id)
          this.model.sort_listed = this.selected_shortlist_user
        }
        
      })
    }
    getEmployeeStatusList() {
      this.apiService.getLeadsStatusList("employeestatus").subscribe((res: any) => {
        this.emp_type_list = res.data
        const desiredStatusOrder = ['full_time', 'part_time','exemployee'];
        this.emp_type_list.sort((a,b) => {
          const aIndex = desiredStatusOrder.indexOf(a.name)
          const bIndex = desiredStatusOrder.indexOf(b.name)
          return aIndex - bIndex
        })
        this.emp_type_list = this.emp_type_list.filter((status) => {
          return status.name === 'full_time' || status.name === 'part_time';
        });
      })
    }
    getEmpTypeId(event){
      this.selected_type
    }
    getStatusList(){
      this.apiService.getTagByTagCatgoryId(this.opening_status_cat_id).subscribe((res:any)=>{
        this.status_list=res.data
      })
    }
    getStatusId(event){
      this.selected_status
    }
    getCategoryList(){
      this.apiService.getTagByTagCatgoryId(this.opening_cate_cat_id).subscribe((res:any)=>{
        this.category_list=res.data
      })
    }
    getCategoryId(event){
      this.selected_category
    }
    getJobList(){
      this.apiService.getAllJobs(1,100).subscribe((res:any)=>{
        this.job_list=res?.data?.items
      })
    }
    getJobId(event){
      this.selected_job
    }
    getCompanyList(){
      this.apiService.getBusinessByTypeId('6325ce10bc4b543c7a2429ad').subscribe((res:any)=>{
        this.company_list=res?.data
      })
    }
    getCompanyId(event){
      this.selected_company

      this.apiService.getBusinessById(this.selected_company).subscribe((res:any)=>{
        this.model.contact_phone = res?.data?.phone
        this.model.website = res?.data?.website
        this.model.contact_email = res?.data?.email
      })
    }
  getAllCandidate(){
    this.apiService.getAllCandidates(1, 100).subscribe((res: any) => {
        this.users_list=res?.data?.items
      })
    }
  getUserId(event) {
    this.selected_user
  }
  getShortUserId(event) {
    this.selected_shortlist_user
  }
  
    get rf() {
      return this.OpeningForm.controls;
    }
    submit(){
  
      let body ={
        title: this.OpeningForm.value.title,
        salary: this.OpeningForm.value.salary,
        website:  this.model.website ?  this.model.website  :this.OpeningForm.value.website,
        deadline: this.model.deadline,
        location: this.OpeningForm.value.location,
        // posted_date: this.model.posted_date,
        description: this.OpeningForm.value.description,
        contact_email:  this.model.contact_email?this.model.contact_email: this.OpeningForm.value.contact_email ,
        contact_phone: this.model.contact_phone?this.model.contact_phone: this.OpeningForm.value.contact_phone,
        responsibilities: this.OpeningForm.value.responsibilities,
        status: '64c2466d6ae6f958da59faee',
        // job_id: this.selected_job,
        company: this.selected_company,
        category: this.selected_category,
        employment_type: this.selected_type,
        notes: this.OpeningForm.value.notes,
        admin_notes: this.OpeningForm.value.admin_notes,
        experience: this.experince_Value,
        applied_for :this.selected_user,
        sort_listed :this.selected_shortlist_user,
        
        
      }
    if(!this.opening_id){
      this.apiService.createOpening(body).subscribe((res:any)=>{
        if(res.statusCode === 200){
          this.toastr.success('Create Successfully')
        this.route.navigate(['/openings/list'])    
        }
        else{this.toastr.error(res.error)}
      })
    }
    if(this.opening_id){
      this.model.employment_type = this.selected_type
      this.model.job_id = this.selected_job
      this.model.category = this.selected_category
      this.model.company = this.selected_company
      this.model.status = this.selected_status
      this.model.applied_for = this.selected_user
      this.model.sort_listed = this.selected_shortlist_user
      this.apiService.updateOpening(this.opening_id,this.model).subscribe((res:any)=>{
        if(res.statusCode === 200){
          this.toastr.success('Update Successfully')
        // this.route.navigate(['/openings/list'])  
        window.history.back()  
        }
        else{this.toastr.error(res.error)}
      })
    }
    }

   back(){
    this.route.navigate(['/openings/list'])    
   } 
    
  }
  